import useEditingStore from '@hooks/useEditingStore';
import useLangString from '@hooks/useLangString';
import { $tourData } from '@stores/dataStores';
import { $editingCopyright, $editingUIColor } from '@stores/editingStores';
import { TemplateId } from '@types';
import { getTemplateConfig } from '@utils/templateConfig';

function WCopyrightREA() {
  const copyright = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.config?.copyright,
    $editing: $editingCopyright.store,
  });
  const ui = useEditingStore({
    $data: $tourData,
    dataFn: (state) => {
      const ui = state.config?.ui;
      const defaultUI =
        getTemplateConfig(TemplateId.realEstateA)('uiColor') ?? {};
      if (!ui) return defaultUI;
      return { ...defaultUI, ...ui };
    },
    $editing: $editingUIColor.store,
  });

  const lang = useLangString({ title: ['免责声明', 'Disclaimer'] }, []);

  if (!copyright?.content) return null;

  const title = copyright.title || lang.title;

  return (
    <div
      className="absolute left-30 bottom-24 w-90 truncate"
      style={{ color: `rgba(${ui.fontColor})` }}
    >
      {title}
    </div>
  );
}

export default WCopyrightREA;
